import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from "@angular/common/http";
import { EMPTY, Observable, of, throwError } from "rxjs";
import { catchError, map, switchMap, takeUntil } from "rxjs/operators";
import { StorageService } from "../routes/services/storage.service";
import { Router } from "@angular/router";

@Injectable()
export class CancelInterceptor implements HttpInterceptor {
  constructor(public storageService: StorageService, public router: Router) {}

  /**
   * Adjunta el manejo de errores comun a cada peticion saliente.
   * @param request Peticion original, con las cabeceras de control del interceptor.
   * @param next Siguiente manejador de la cadena.
   * @returns Flujo de la peticion con su manejo de errores aplicado.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const clonedRequest = request.clone({
      headers: request.headers.delete("destroy_petition").delete("silent_error")
    });

    const destroy_petition = request.headers.get("destroy_petition") === "false";
    /* Peticiones de fondo: el error se propaga a quien la hizo, pero no se le
       muestra al usuario, porque no responde a ninguna accion suya. */
    const silent_error = request.headers.get("silent_error") === "true";

    const handleError = (error: HttpErrorResponse) => {
      return silent_error ? throwError(error) : this.storageService.validateError(error);
    };

    if (destroy_petition) {
      return next.handle(clonedRequest).pipe(catchError(handleError));
    }

    return next
      .handle(clonedRequest)
      .pipe(takeUntil(this.storageService.destroy$), catchError(handleError));
  }
}
